<template>
  <b-col>
    <HotelInfo :result="result" />
    <div v-for="pack in result.packages" :key="'packageInfo'+pack.id">
      <PackageInfo :pack="pack" :currency="currency"></PackageInfo>
    </div>
  </b-col>
</template>

<script>
import HotelInfo from '@/app/private/shared/components/hotel_info'
import PackageInfo from './package_info'

export default {
  name: 'detailedInfo',
  props: ['result', 'currency'],
  components: { HotelInfo, PackageInfo }
}
</script>
